import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["nameInput", "submitButton"];
  static values = {
    open: { type: Boolean, default: false }
  };

  connect() {
    if (this.openValue) {
      Modal.getOrCreateInstance(this.element).show();
    }

    this.validate();
  }

  modalShown() {
    if (this.hasNameInputTarget) {
      this.nameInputTarget.focus();
      this.nameInputTarget.select();
    }

    this.validate();
  }

  validate() {
    if (!this.hasSubmitButtonTarget) return;

    this.submitButtonTarget.disabled = this.companyName() === "";
  }

  companyName() {
    if (!this.hasNameInputTarget) return "";

    return this.nameInputTarget.value.trim();
  }
}
